import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Breadcumb from './Breadcumb';
import AboutUs from './AboutUs';
import MeetFounders from './MeetFounders';
import WhyChoose from './WhyChoose';
import { fetchMetadata } from '../utils/api';

function Main() {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const data = await fetchMetadata();
        const aboutMetadata = data.find((item) => item.pageName === 'about-us');
        if (!aboutMetadata) {
          setError('About Us page metadata not found');
          setLoading(false);
          return;
        }
        setSeoData(aboutMetadata);
        setLoading(false);
      } catch (err) {
        setError('Failed to load SEO metadata');
        setLoading(false);
      }
    };
    loadMetadata();
  }, []);

  return (
    <>
      <Helmet>
        <title>{seoData?.title || 'About Us | Bluelagoon Travels'}</title>
        <meta
          name='description'
          content={
            seoData?.description || 'Discover Bluelagoon Travels, your trusted travel partner.'
          }
        />
        <meta
          name='keywords'
          content={seoData?.keywords || 'about, travel company'}
        />
        <meta
          name='pageName'
          content={seoData?.pageName || 'about-us'}
        />
      </Helmet>
      <Breadcumb />
      <AboutUs />
      <MeetFounders />
      <WhyChoose />
    </>
  );
}

export default Main;
